(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8779);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3838);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/A1+Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    size = props.size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
Icon.defaultProps = {
  screenReaderContent: null,
  developmentUrl: null,
  className: null,
  size: 24
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 1257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(287);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1491);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

/***/ }),

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 1521:
/***/ (() => {



/***/ }),

/***/ 1491:
/***/ (() => {



/***/ }),

/***/ 8779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 3838:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Breadcrumbs)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(8779);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
;// CONCATENATED MODULE: external "@babel/runtime/helpers/toConsumableArray"
const toConsumableArray_namespaceObject = require("@babel/runtime/helpers/toConsumableArray");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_namespaceObject);
;// CONCATENATED MODULE: external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(3838);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: external "uuid"
const external_uuid_namespaceObject = require("uuid");
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(1257);
;// CONCATENATED MODULE: external "@able/web/dist/Breadcrumbs/BreadcrumbsUtilities"
const BreadcrumbsUtilities_namespaceObject = require("@able/web/dist/Breadcrumbs/BreadcrumbsUtilities");
;// CONCATENATED MODULE: external "react-router-dom"
const external_react_router_dom_namespaceObject = require("react-router-dom");
;// CONCATENATED MODULE: external "lodash-es"
const external_lodash_es_namespaceObject = require("lodash-es");
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/Breadcrumbs/Breadcrumbs.tsx




var _excluded = ["className", "breadcrumbs", "developmentUrl", "id", "setBackgroundToWhite"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function usePrevious(value) {
  var ref = (0,external_react_namespaceObject.useRef)();
  (0,external_react_namespaceObject.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
function currentAndPreviousCrumbsAreIdentical(currentBreadcrumbs, previousBreadcrumbs) {
  return currentBreadcrumbs.length === previousBreadcrumbs.length && currentBreadcrumbs.every(function (v, i) {
    return v === previousBreadcrumbs[i];
  });
}
function Breadcrumbs(props) {
  var className = props.className,
    breadcrumbs = props.breadcrumbs,
    developmentUrl = props.developmentUrl,
    id = props.id,
    setBackgroundToWhite = props.setBackgroundToWhite,
    other = objectWithoutProperties_default()(props, _excluded);
  var expandItemNode = {
    isExpandItem: true,
    url: '',
    to: '',
    state: undefined,
    events: undefined,
    label: '',
    index: 1
  };
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    widthsAreCalculated = _useState2[0],
    setWidthsAreCalculated = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(0),
    _useState4 = slicedToArray_default()(_useState3, 2),
    containerWidth = _useState4[0],
    setContainerWidth = _useState4[1];
  var _useState5 = (0,external_react_namespaceObject.useState)(''),
    _useState6 = slicedToArray_default()(_useState5, 2),
    currentClassModifier = _useState6[0],
    setCurrentClassModifier = _useState6[1];
  var _useState7 = (0,external_react_namespaceObject.useState)({
      height: window.innerHeight,
      width: window.innerWidth
    }),
    _useState8 = slicedToArray_default()(_useState7, 2),
    dimensions = _useState8[0],
    setDimensions = _useState8[1];
  var previousBreadcrumbs = usePrevious(breadcrumbs);
  var previousContainerWidth = usePrevious(containerWidth);
  var computeBreadcrumbsWithExpand = function computeBreadcrumbsWithExpand(breadcrumbs) {
    setWidthsAreCalculated(false);
    var breadcrumbsCopy = toConsumableArray_default()(breadcrumbs);
    breadcrumbsCopy.splice(1, 0, expandItemNode);
    breadcrumbsCopy = breadcrumbsCopy.map(function (breadcrumb, index) {
      return _objectSpread({
        index: index
      }, breadcrumb);
    });
    return breadcrumbsCopy;
  };
  var breadcrumbsWithExpandItem = (0,external_react_namespaceObject.useMemo)(function () {
    return computeBreadcrumbsWithExpand(breadcrumbs);
  }, [breadcrumbs]);
  var patternClass = setBackgroundToWhite ? "able-Breadcrumbs--white-bg" : 'able-Breadcrumbs';
  var showSucceedingItemsClass = 'breadcrumbs-show-succeeding-items';
  var classes = classnames_default()(patternClass, className);
  var breadCrumbsInitialState = function breadCrumbsInitialState() {
    return breadcrumbsWithExpandItem.map(function (_ref, index) {
      var label = _ref.label,
        url = _ref.url,
        to = _ref.to,
        state = _ref.state,
        events = _ref.events,
        isExpandItem = _ref.isExpandItem;
      if (!isExpandItem) {
        return {
          label: label,
          url: url,
          to: to,
          state: state,
          events: events,
          isExpandItem: false,
          isShowing: true,
          width: 0,
          showSucceedingItems: false,
          index: index
        };
      }
      return {
        label: label,
        url: url,
        to: to,
        state: state,
        events: events,
        isExpandItem: isExpandItem,
        isShowing: true,
        width: 0,
        showSucceedingItems: false,
        index: index
      };
    });
  };
  var returnBreadcrumbsState = function returnBreadcrumbsState() {
    var breadCrumbsHaveChanged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (breadCrumbsHaveChanged && !widthsAreCalculated) {
      return breadCrumbsInitialState();
    }
    return breadcrumbsState && breadcrumbsState.length && widthsAreCalculated ? breadcrumbsState : breadCrumbsInitialState();
  };
  var _useState9 = (0,external_react_namespaceObject.useState)(returnBreadcrumbsState()),
    _useState10 = slicedToArray_default()(_useState9, 2),
    breadcrumbsState = _useState10[0],
    setBreadcrumbsState = _useState10[1];
  var createBreadcrumbRefs = function createBreadcrumbRefs() {
    return breadcrumbsWithExpandItem.map(function () {
      return /*#__PURE__*/(0,external_react_namespaceObject.createRef)();
    });
  };
  var containerRef = (0,external_react_namespaceObject.useRef)();
  var breadcrumbRefs = (0,external_react_namespaceObject.useRef)(createBreadcrumbRefs());
  var breadcrumbsStateChange = function breadcrumbsStateChange(breadcrumbsHaveChanged) {
    if (breadcrumbsHaveChanged) {
      setBreadcrumbsState(returnBreadcrumbsState(breadcrumbsHaveChanged));
      breadcrumbRefs.current = createBreadcrumbRefs();
    } else {
      setBreadcrumbsState(returnBreadcrumbsState());
    }
  };
  (0,external_react_namespaceObject.useEffect)(function () {
    if (previousBreadcrumbs && !currentAndPreviousCrumbsAreIdentical(breadcrumbs, previousBreadcrumbs)) {
      breadcrumbsStateChange(true);
    }
  }, [breadcrumbs.length]);

  // Setup debounce
  (0,external_react_namespaceObject.useEffect)(function () {
    var debouncedHandleResize = (0,external_lodash_es_namespaceObject.debounce)(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }, 20);
    window.addEventListener('resize', debouncedHandleResize);
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);
  var calculateBreadcrumbWidth = function calculateBreadcrumbWidth(ref) {
    return ref && ref.current && ref.current.clientWidth || 0;
  };
  var setBreadcrumbsBaseState = function setBreadcrumbsBaseState() {
    var updatedBreadcrumbListState = breadcrumbsState.map(function (breadcrumb, index) {
      return _objectSpread(_objectSpread({}, breadcrumb), {}, {
        isShowing: false,
        showSucceedingItems: false,
        width: calculateBreadcrumbWidth(breadcrumbRefs.current[index])
      });
    });
    setBreadcrumbsState(updatedBreadcrumbListState);
    setWidthsAreCalculated(true);
  };
  var calculateShowingBreadcrumbs = function calculateShowingBreadcrumbs() {
    var allCrumbWidthsWithoutExpander = 0;
    var combinedBreadcrumbWidths = 0;
    var breadcrumbWidthIsFull = false;
    var currentBreadcrumbListState = toConsumableArray_default()(breadcrumbsState);
    currentBreadcrumbListState.forEach(function (breadcrumb) {
      allCrumbWidthsWithoutExpander += breadcrumb.width || 0;
    });
    if (allCrumbWidthsWithoutExpander < containerWidth) {
      setCurrentClassModifier('show');
    } else {
      // Default value: no index will be that high
      var lastIndexIsShowing = 1000;
      if (currentBreadcrumbListState[0].width && currentBreadcrumbListState[1].width) {
        combinedBreadcrumbWidths = currentBreadcrumbListState[0].width + currentBreadcrumbListState[1].width;
      }
      currentBreadcrumbListState = currentBreadcrumbListState.reverse().map(function (breadcrumb, index) {
        if (breadcrumb.width && !breadcrumbWidthIsFull) {
          if (combinedBreadcrumbWidths + breadcrumb.width < containerWidth) {
            combinedBreadcrumbWidths += breadcrumb.width;
            lastIndexIsShowing = index;
            return _objectSpread(_objectSpread({}, breadcrumb), {}, {
              isShowing: true,
              showSucceedingItems: false
            });
          }
        }
        breadcrumbWidthIsFull = true;
        if (lastIndexIsShowing === index - 1) {
          return _objectSpread(_objectSpread({}, breadcrumb), {}, {
            isShowing: false,
            showSucceedingItems: true
          });
        }
        return _objectSpread(_objectSpread({}, breadcrumb), {}, {
          showSucceedingItems: false
        });
      }).reverse();
      setBreadcrumbsState(currentBreadcrumbListState);
      setCurrentClassModifier('collapsed');
    }
  };
  var BreadcrumbListItem = function BreadcrumbListItem(_ref2) {
    var url = _ref2.url,
      to = _ref2.to,
      state = _ref2.state,
      events = _ref2.events,
      label = _ref2.label,
      _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? NaN : _ref2$index,
      showSucceedingItems = _ref2.showSucceedingItems;
    if (!url && !to) {
      console.warn('ABLE: breadcrumb defined without "url" or "to" values');
    }
    var link = /*#__PURE__*/(0,jsx_runtime_.jsx)("a", _objectSpread(_objectSpread({
      href: url
    }, events), {}, {
      children: label
    }));
    if (to) {
      link = /*#__PURE__*/(0,jsx_runtime_.jsx)(external_react_router_dom_namespaceObject.Link, _objectSpread(_objectSpread({
        to: to,
        state: state
      }, events), {}, {
        children: label
      }));
    }

    // Always show first <li> (Home) || show all until isShowing !== undefined
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("li", {
      ref: breadcrumbRefs.current[index],
      className: showSucceedingItems ? showSucceedingItemsClass : '',
      children: link
    }, "breadcrumb".concat((0,external_uuid_namespaceObject.v4)()));
  };
  var ExpandItem = function ExpandItem(_ref3) {
    var index = _ref3.index;
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("li", {
      ref: breadcrumbRefs.current[index],
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("button", {
        id: "BreadcrumbExpander",
        "aria-label": "Expand breadcrumbs",
        type: "button",
        onClick: function onClick() {
          setCurrentClassModifier('expanded');
        },
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
          icon: "More",
          developmentUrl: developmentUrl
        })
      })
    }, "breadcrumbsWithExpandItem".concat((0,external_uuid_namespaceObject.v4)()));
  };
  var children = function children() {
    var objectToBuildBreadcrumbsFrom = breadcrumbsWithExpandItem;
    if (widthsAreCalculated) {
      objectToBuildBreadcrumbsFrom = breadcrumbsState;
    }
    return objectToBuildBreadcrumbsFrom.map(function (childProps, index) {
      var isExpandItem = childProps.isExpandItem;
      if (isExpandItem) {
        return /*#__PURE__*/(0,jsx_runtime_.jsx)(ExpandItem, _objectSpread(_objectSpread({}, childProps), {}, {
          index: childProps.index || index
        }), "breadcrumbsWithExpandItem".concat((0,external_uuid_namespaceObject.v4)()));
      } else {
        return /*#__PURE__*/(0,jsx_runtime_.jsx)(BreadcrumbListItem, _objectSpread({}, childProps), "breadcrumbsWithExpandItem".concat((0,external_uuid_namespaceObject.v4)()));
      }
    });
  };

  // Set Container width
  (0,external_react_namespaceObject.useEffect)(function () {
    if (containerRef.current && containerRef.current.offsetWidth) {
      var _containerWidth = (0,BreadcrumbsUtilities_namespaceObject.getElementContentWidth)(containerRef.current);
      setContainerWidth(_containerWidth);
    }
  }, [dimensions.width]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (currentClassModifier !== 'expanded') {
      if (previousContainerWidth !== undefined && previousContainerWidth >= 0) {
        var lgBreakpoint = window.matchMedia('min-width: 105rem');
        if (previousContainerWidth < 1428 && lgBreakpoint.matches || previousContainerWidth >= 1428 && !lgBreakpoint.matches) {
          setWidthsAreCalculated(false);
        } else {
          calculateShowingBreadcrumbs();
          setWidthsAreCalculated(true);
        }
      }
    }
  }, [containerWidth]);

  // Base Breadcrumbs State
  (0,external_react_namespaceObject.useEffect)(function () {
    setBreadcrumbsBaseState();
  }, []);

  // On Widths are calculated
  (0,external_react_namespaceObject.useEffect)(function () {
    if (widthsAreCalculated) {
      calculateShowingBreadcrumbs();
    } else {
      // triggers reset of breadcrumbsBaseState
      setCurrentClassModifier('');
    }
  }, [widthsAreCalculated]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (currentClassModifier === '') {
      setBreadcrumbsBaseState();
    }
    if (currentClassModifier === 'expanded') {
      if (breadcrumbRefs.current[2].current) {
        breadcrumbRefs.current[2].current.setAttribute('tabindex', '-1');
        breadcrumbRefs.current[2].current.focus();
      }
    }
  }, [currentClassModifier]);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("nav", _objectSpread(_objectSpread({
    "aria-label": "Breadcrumbs",
    className: "".concat(patternClass, "--").concat(currentClassModifier, " ").concat(classes),
    id: id
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ol", {
      ref: containerRef,
      children: children()
    })
  }));
}
Breadcrumbs.defaultProps = {
  className: undefined,
  developmentUrl: undefined,
  id: 'Breadcrumbs'
};
/* harmony default export */ const Breadcrumbs_Breadcrumbs = (Breadcrumbs);
// EXTERNAL MODULE: ./src/Breadcrumbs/Breadcrumbs.scss
var src_Breadcrumbs_Breadcrumbs = __webpack_require__(1521);
;// CONCATENATED MODULE: ./src/Breadcrumbs/index.ts


/* harmony default export */ const src_Breadcrumbs = (Breadcrumbs_Breadcrumbs);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});